import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, Gauge, ArrowRight } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";

const NAV_LINKS = [
    { label: "Ablauf", href: "/#ablauf" },
    { label: "Produkte", href: "/#produkte" },
    { label: "Vergleich", href: "/#vergleich" },
    { label: "Referenzen", href: "/#referenzen" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="main-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
                scrolled ? "glass border-b border-white/10" : "bg-transparent"
            }`}
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
                        <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary red-glow">
                            <Gauge className="h-5 w-5 text-white" strokeWidth={2} />
                        </div>
                        <div className="leading-none">
                            <div className="font-heading text-lg font-extrabold tracking-tight text-white">
                                NA PERFORMANCE
                            </div>
                            <div className="text-[10px] tracking-[0.25em] uppercase text-primary font-semibold">
                                PerformanceOS
                            </div>
                        </div>
                    </Link>

                    <nav className="hidden md:flex items-center gap-8">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                className="text-sm font-medium text-[#A1A1AA] hover:text-white transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden md:flex items-center gap-3">
                        <button
                            data-testid="nav-analyse-btn"
                            onClick={() => navigate("/analyse")}
                            className="group inline-flex items-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-bold text-white hover:bg-[#FF3B30] transition-colors"
                        >
                            Analyse starten
                            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                        </button>
                    </div>

                    <div className="md:hidden">
                        <Sheet>
                            <SheetTrigger asChild>
                                <button
                                    data-testid="mobile-menu-btn"
                                    aria-label="Menü"
                                    className="flex h-10 w-10 items-center justify-center rounded-md border border-border text-white"
                                >
                                    <Menu className="h-5 w-5" />
                                </button>
                            </SheetTrigger>
                            <SheetContent
                                side="right"
                                className="bg-[#0A0A0A] border-l border-border text-white w-[80%]"
                            >
                                <div className="mt-10 flex flex-col gap-1">
                                    {NAV_LINKS.map((l) => (
                                        <SheetClose asChild key={l.href}>
                                            <a
                                                href={l.href}
                                                className="rounded-md px-3 py-3 text-lg font-medium text-[#A1A1AA] hover:text-white hover:bg-surface transition-colors"
                                            >
                                                {l.label}
                                            </a>
                                        </SheetClose>
                                    ))}
                                    <SheetClose asChild>
                                        <button
                                            data-testid="mobile-analyse-btn"
                                            onClick={() => navigate("/analyse")}
                                            className="mt-4 inline-flex items-center justify-center gap-2 rounded-md bg-primary px-5 py-3.5 text-base font-bold text-white"
                                        >
                                            Analyse starten <ArrowRight className="h-4 w-4" />
                                        </button>
                                    </SheetClose>
                                </div>
                            </SheetContent>
                        </Sheet>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
